<!--
 * @Author: soul(佘家骏) 
 * @Date: 2021-11-09 18:10:10
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2021-11-23 17:19:11
 * @Description: file content
 -->
<template>
  <div :style="option.style" @click="fn">
    <img
      :src="imgHost + option.url + '?v=' + $config.OSSVersion"
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    option: Object
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    fn() {
      this.$emit('click')
    }
  },
  created() {
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
</style>